import React from "react";

const NavatticIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_844)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.6613 31.0774L12.7725 32.5348C11.7858 34.1525 10.3743 35.4686 8.69146 36.3396C7.00866 37.2106 5.11913 37.6033 3.22863 37.4748L2.04706 37.391L0.00779642 37.1698C-0.0656397 37.0652 0.379684 35.1361 1.34471 31.3824C6.26587 29.1972 10.3717 29.0946 13.6603 31.0764L13.6613 31.0774ZM35.7655 21.8668L34.0313 29.265C34.0332 29.3234 34.0021 29.378 33.9513 29.4062C24.1419 34.8349 11.9986 23.2075 2.18452 28.4723C2.08001 28.5288 1.98398 28.509 1.98021 28.3894L3.67207 21.5203C3.67019 21.461 3.70126 21.4074 3.7521 21.3791C13.5615 15.9505 26.0616 27.7596 35.4162 21.7246C35.5076 21.6653 35.7627 21.7463 35.7655 21.8668ZM38.0759 11.8644L36.3417 19.2626C36.3436 19.321 36.3125 19.3756 36.2617 19.4039C26.4523 24.8325 14.309 13.2051 4.49493 18.4699C4.39042 18.5264 4.29439 18.5066 4.29063 18.3871L5.98248 11.518C5.9806 11.4586 6.01167 11.405 6.06251 11.3767C15.8719 5.94811 28.372 17.7572 37.7266 11.7223C37.818 11.6629 38.0731 11.7449 38.0759 11.8654V11.8644ZM39.9919 2.52204C40.0738 2.61995 39.5371 4.66486 38.381 8.65866C33.7187 11.2336 29.6628 11.678 26.2132 9.99086L27.1726 8.19639C27.9949 6.65858 29.1923 5.35334 30.6537 4.40171C32.115 3.45008 33.793 2.88287 35.532 2.7527L38.0411 2.57759C39.3065 2.4985 39.957 2.47967 39.9919 2.52204Z",
  fill: "#202669"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_844"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(NavatticIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;